import { render, staticRenderFns } from "./AlarmRecordCarrier.vue?vue&type=template&id=d8a9ca16&scoped=true&"
import script from "./AlarmRecordCarrier.vue?vue&type=script&lang=js&"
export * from "./AlarmRecordCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a9ca16",
  null
  
)

export default component.exports